/* =====================================================================
   v2 — Sayılarla: rakam sayacı
   <span class="v2-num__digits" data-v2-count>170.000</span>
   Kart görünür olunca rakam sıfırdan hedefe sayar. Ayraç, metnin kendi
   ayracıdır (tr'de "."), yani tema hiçbir yerde biçim varsaymaz.
   Rakam olmayan değerler ("2–10", "A+") olduğu gibi bırakılır.
   ===================================================================== */
(function () {
  var SEL = '[data-v2-count]';
  var reduced =
    (window.V2 && window.V2.reduced) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Binlik ayracı olabilecek karakterler: nokta, virgül, boşluk türleri */
  var SEP = /[.,   ]/;
  var SEP_G = /[.,   ]/g;
  var NUMERIC = /^\d$|^\d[\d.,   ]*\d$/;

  function parse(text) {
    var raw = String(text).trim();
    if (!NUMERIC.test(raw)) return null;

    var sep = '';
    var match = raw.match(SEP);
    if (match) sep = match[0];

    var digits = raw.replace(SEP_G, '');
    if (!/^\d+$/.test(digits)) return null;

    var target = parseInt(digits, 10);
    if (!isFinite(target) || target === 0) return null;

    return { target: target, sep: sep };
  }

  function format(value, info) {
    var out = String(value);
    if (!info.sep) return out;
    return out.replace(/\B(?=(\d{3})+(?!\d))/g, info.sep);
  }

  function run(el) {
    if (el.dataset.v2CountDone === 'true') return;
    el.dataset.v2CountDone = 'true';

    var info = parse(el.textContent);
    if (!info) return;

    var final = el.textContent.trim();

    if (reduced) {
      el.textContent = final;
      return;
    }

    var duration = 1100;
    var start = null;

    function step(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      /* easeOutExpo — hızlı başlar, hedefe yumuşak oturur */
      var eased = t === 1 ? 1 : 1 - Math.pow(2, -9 * t);
      el.textContent = format(Math.round(info.target * eased), info);
      if (t < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = final;
      }
    }

    el.textContent = format(0, info);
    window.requestAnimationFrame(step);
  }

  var observer = null;

  function bind(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) return;

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            run(entry.target);
          });
        },
        { threshold: 0.35 }
      );
    }

    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.v2CountDone === 'true') return;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }

  /* Tema düzenleyicide bölüm yeniden yüklendiğinde tekrar bağlan */
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
